import React, { useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import SectionLoader from '../../../components/SectionLoader';
import DeleteConfirmation from './DeleteConfirmation';
import moment from "moment";

import axios from 'axios';
import '../../../assets/scss/component.scss'
import { error, success, getApiMessage } from "../../../notify";

const SiteCategories = (props) => {
    let history = useNavigate();
    const ERR_NETWORK_MESSAGE = 'Server is not available.'
    const token = sessionStorage.getItem("revizeTrainingToken");
    const [domainKey, setDomainKey] = useState("");
    const [domainName, setDomainName] = useState("");
    const [siteId, setSiteId] = useState("");
    const [categoryData, setCategoryData] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const categoryApi = `${process.env.REACT_APP_SERVER_URL}/api/category-site/?siteId=`;
    const addCategoryApi = `${process.env.REACT_APP_SERVER_URL}/api/category`;
    const deleteCategoryApi = `${process.env.REACT_APP_SERVER_URL}/api/category/`;
    const updateCategoryApi = `${process.env.REACT_APP_SERVER_URL}/api/category/`;
    const [uuid, setUuid] = useState(null);
    const [categoryId, setCategoryId] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [description, setDescription] = useState("");
    const defaultShowInBot = true;
    const [showInBot, setShowInBot] = useState(defaultShowInBot);
    const [categoryNameError, setCategoryNameError] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [confirmMessage, setConfirmMessage] = useState(null);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);

    // Updated search states
    const [searchInputValue, setSearchInputValue] = useState("");
    const [showClearButton, setShowClearButton] = useState(false);

    const [showAddCategory, setShowAddCategory] = useState(false);

    const [currentUpdateCategory, setCurrentUpdateCategory] = useState({
        categoryName: '',
        description: '',
        showInBot: defaultShowInBot
    });

    const handleCloseAddCategory = () => {
        setShowAddCategory(false);
        setCategoryName("");
        setDescription("");
        setCategoryNameError("");
        setDescriptionError("");
        setShowInBot(true);
    }
    const handleShowAddCategory = () => setShowAddCategory(true);

    const [showUpdateCategory, setShowUpdateCategory] = useState(false);
    const handleCloseUpdateCategory = () => {
        setShowUpdateCategory(false);
        setCategoryNameError("");
        setDescriptionError("");
        setShowInBot(true);
    };
    const handleShowUpdateCategory = (id, name, description, showinbot) => {
        setShowUpdateCategory(true);
        setCategoryId(id);
        setCategoryName(name);
        setDescription(description);
        setShowInBot(showinbot);
    }

    // Updated Search functionality - matches SiteUsers.js pattern
    const handleSearch = () => {
        if (searchInputValue.trim() !== "") {
            setShowClearButton(true);
            const filtered = categoryData.filter(item =>
                item.name.toLowerCase().includes(searchInputValue.toLowerCase()) ||
                item.description.toLowerCase().includes(searchInputValue.toLowerCase())
            );
            setFilteredCategories(filtered);
        }
    };

    const handleClearSearch = () => {
        setSearchInputValue("");
        setShowClearButton(false);
        setFilteredCategories(categoryData);
    };

    const handleSearchInputChange = (event) => {
        setSearchInputValue(event.target.value);
        if (event.target.value.trim() === "") {
            setShowClearButton(false);
            setFilteredCategories(categoryData);
        }
    };

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    // Refresh functionality
    const handleRefresh = () => {
        if (siteId) {
            fetchData(siteId);
            success("Categories refreshed successfully.", true);
        }
    };

    let loaded = false;
    const location = useLocation();

    useEffect(() => {
        if (!loaded && token) {
            // eslint-disable-next-line
            loaded = true;
            if (null === location.state) {
                history('/site')
                return;
            }
            setSiteId(location.state.siteId);
            setDomainName(location.state.siteName);
            setDomainKey(location.state.siteKey);
            fetchData(location.state.siteId);
        }

    }, [])

    async function fetchData(siteId) {
        if (!siteId) return;
        setIsLoading(true);
        const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
        try {
            const response = await axios.get(categoryApi + siteId, { headers: headers });
            const data = response.data;
            setCategoryData(data);
            setFilteredCategories(data);
        } catch (err) {
            if (err === 'ERR_NETWORK') {
                error(ERR_NETWORK_MESSAGE, true)
            } else {
                error(err.response.data.detail, true)
            }
            history('/site');
        } finally {
            setIsLoading(false);
        }
    }

    const handleCategoryName = (event) => {
        setCategoryName(event.trim());
    };


    const handleShowInBot = () => {
        setShowInBot(!showInBot);
    };

    const handleDescription = (event) => {
        setDescription(event.trim());
    };

    const validateCategoryName = (event) => {
        event.preventDefault();
        const categoryNamePattern = /[a-zA-Z]/;
        if (categoryName !== "") {
            setCategoryNameError("")
            if (!categoryNamePattern.test(categoryName)) {
                setCategoryNameError("Category Name is invalid");
            }
        } else {
            setCategoryNameError("Category Name is mandatory");
        }
    }

    const validateDescription = (event) => {
        event.preventDefault();
        const descriptionPattern = /[a-zA-Z]/;
        if (description !== "") {
            setDescriptionError("")
            if (!descriptionPattern.test(description)) {
                setDescriptionError("Description is invalid");
            }
        } else {
            setDescriptionError("Description is mandatory");
        }
    }

    const addCategory = () => {
        if (token) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            var data = JSON.stringify({
                "name": categoryName,
                "website_id": siteId,
                "description": description,
                "show_in_bot": showInBot
            });

            axios.post(addCategoryApi, data, { headers: headers })
                .then((response) => {
                    const data = response.data;
                    const newCategories = [...categoryData, data];
                    setCategoryData(newCategories);
                    setFilteredCategories(newCategories);
                    success("Category added successfully.", true);
                })
                .catch((err) => {
                    if (err === 'ERR_NETWORK') {
                        error(ERR_NETWORK_MESSAGE, true)
                    } else {
                        error(err.response.data.detail, true)
                    }
                });
        }
        setCategoryName("");
        setDescription("");
        setShowInBot(true);
    };

    const updateCategory = () => {
        const hasChanges = (
            currentUpdateCategory.categoryName !== categoryName ||
            currentUpdateCategory.description !== description ||
            currentUpdateCategory.showInBot !== showInBot
        );

        if (token && hasChanges) {
            const headers = { "Content-Type": "application/json", "Authorization": "Bearer " + token };
            const data = JSON.stringify({
                "category_request": {
                    "name": categoryName,
                    "website_id": siteId,
                    "description": description,
                    "show_in_bot": showInBot
                }
            });

            axios.put(updateCategoryApi + categoryId, data, { headers: headers })
                .then(() => {
                    success("Category updated successfully.", true);
                    updateCategoryData(categoryId);
                })
                .catch((err) => {
                    if (err.message === 'Network Error') {
                        error(ERR_NETWORK_MESSAGE, true);
                    } else {
                        error(err.response?.data?.detail || "An error occurred", true);
                    }
                });

            setCategoryName("");
            setDescription("");
        } else if (!hasChanges) {
            console.log("No changes detected.");
        }
    };


    const updateCategoryData = (categoryId) => {
        const currentCategoryIndex = categoryData.findIndex((category) => category.id === categoryId);
        const updatedCategory = Object.assign({}, categoryData[currentCategoryIndex]);
        updatedCategory.name = categoryName;
        updatedCategory.description = description;
        updatedCategory.website_id = siteId
        updatedCategory.show_in_bot = showInBot
        const newCategoryData = categoryData.slice();
        newCategoryData[currentCategoryIndex] = updatedCategory;
        setCategoryData(newCategoryData);
        setFilteredCategories(newCategoryData);
    };

    const deleteCategory = () => {
        const headers = { "accept": "application/json", "Authorization": "Bearer " + token };
        console.log("delete called")
        axios.delete(deleteCategoryApi + uuid + "/?websiteRef=" + domainKey, { headers: headers })
            .then((response) => {
                const data = response.data;
                success(getApiMessage(data, "Category deleted successfully."), true);
                const newCategories = categoryData.filter((val) => {
                    return val.uuid !== uuid;
                });
                setCategoryData(newCategories);
                setFilteredCategories(newCategories);
            })
            .catch((err) => {
                if (err === 'ERR_NETWORK') {
                    error(ERR_NETWORK_MESSAGE, true)
                } else {
                    const detail = err && err.response && err.response.data
                        ? err.response.data.detail || err.response.data.message || err.response.data
                        : null;
                    error(detail || "Unable to delete category", true)
                }
            });

        setDeleteConfirmationModal(false);
    };

    const [proceedDelete, setProceedDelete] = useState(false);
    const showDeleteModal = (uuid, categoryName, category_document_count) => {
        if (category_document_count === undefined | category_document_count === 0) {
            setUuid(uuid);
            setConfirmMessage("Are you sure you want to delete the category: " + categoryName + "?");
            setDeleteConfirmationModal(true);
            setProceedDelete(true);
            loaded = true;
        } else {
            setConfirmMessage("The category " + categoryName + " cannot be deleted. There are trained documents for category. ");
            setDeleteConfirmationModal(true);
            setProceedDelete(false);
        }
    };

    // Hide the modal
    const hideDeleteConfirmationModal = () => {
        setDeleteConfirmationModal(false);
    };

    const handleModalShow = () => {
        setCurrentUpdateCategory({
            categoryName: categoryName,
            description: description,
        });
    };

    const areAllCategoryFieldsFilled = categoryName !== "" && description !== "" && categoryNameError === "" && descriptionError === "";

    // Icons (same as in AllowedExternalWebsites.js)
    const EditIcon = () => (
        <svg width="16" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7476 20.4428H21.0002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12.78 3.79479C13.5557 2.86779 14.95 2.73186 15.8962 3.49173C15.9485 3.53296 17.6295 4.83879 17.6295 4.83879C18.669 5.46719 18.992 6.80311 18.3494 7.82259C18.3153 7.87718 8.81195 19.7645 8.81195 19.7645C8.49578 20.1589 8.01583 20.3918 7.50291 20.3973L3.86353 20.443L3.04353 16.9723C2.92866 16.4843 3.04353 15.9718 3.3597 15.5773L12.78 3.79479Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.021 6.00098L16.4732 10.1881" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const DeleteIcon = () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const RefreshIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5a6acf" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 2v6h6"></path>
            <path d="M21 12a9 9 0 0 0-15-6.7L3 8"></path>
            <path d="M21 22v-6h-6"></path>
            <path d="M3 12a9 9 0 0 0 15 6.7L21 16"></path>
        </svg>
    );

    const BackIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
            <line x1="5" y1="6" x2="5" y2="18"></line>
        </svg>
    );

    const SearchIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
    );

    const ClearIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    );

    return (
        <div style={{
            fontFamily: '"Inter", sans-serif',
            background: '#f8f9fd',
            margin: 0,
            padding: '20px',
            minHeight: '100vh',
            overflowX: 'auto', // Added horizontal scrolling for the entire container
            width: '100%'
        }}>
            <div style={{
                background: '#fff',
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                padding: '20px',
                minWidth: '800px' // Ensure minimum width for the content
            }}>
                {/* Header Section - Updated with search button and clear button */}
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '15px',
                    flexWrap: 'wrap',
                    gap: '15px'
                }}>
                    <h2 style={{ fontSize: '20px', margin: 0, fontWeight: 600 }}>
                        Categories - {domainName}
                    </h2>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        {/* Search Box with Button - Updated to match SiteUsers.js */}
                        <div style={{ position: 'relative', width: '350px', minWidth: '250px' }}>
                            <input
                                type="text"
                                placeholder="Search categories..."
                                value={searchInputValue}
                                onChange={handleSearchInputChange}
                                onKeyPress={handleSearchKeyPress}
                                style={{
                                    width: '100%',
                                    padding: '8px 68px 8px 12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    fontSize: '14px'
                                }}
                            />
                            <div style={{
                                position: 'absolute',
                                right: '4px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                gap: '4px',
                                alignItems: 'center'
                            }}>
                                {showClearButton && (
                                    <Button
                                        variant="outline-secondary"
                                        onClick={handleClearSearch}
                                        style={{
                                            background: '#5a6acf',
                                            borderRadius: '8px',
                                            width: '28px',
                                            height: '28px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '0',
                                            cursor: 'pointer',
                                            color: '#5a6acf',
                                            transition: 'all 0.2s ease-in-out',
                                            border: '1px solid #ddd',
                                            backgroundColor: 'white',
                                            boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#5a6acf';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'white';
                                            e.currentTarget.style.color = '#5a6acf';
                                        }}
                                    >
                                        <ClearIcon />
                                    </Button>
                                )}
                                <Button
                                    variant="primary"
                                    onClick={handleSearch}
                                    style={{
                                        background: '#5a6acf',
                                        borderRadius: '8px',
                                        width: '28px',
                                        height: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '0',
                                        cursor: 'pointer',
                                        color: '#5a6acf',
                                        transition: 'all 0.2s ease-in-out',
                                        border: '1px solid #ddd',
                                        backgroundColor: 'white',
                                        boxShadow: '0 1px 1px rgba(0, 0, 0, 0.15)',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#5a6acf';
                                        e.currentTarget.style.color = 'white';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'white';
                                        e.currentTarget.style.color = '#5a6acf';
                                    }}
                                >
                                    <SearchIcon />
                                </Button>
                            </div>
                        </div>

                        <Button
                            variant="outline-secondary"
                            onClick={handleShowAddCategory}
                            style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '8px 14px',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            + Add Category
                        </Button>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Button
                            variant="outline-secondary"
                            onClick={handleRefresh}
                            style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '0',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                            }}
                        >
                            <RefreshIcon />
                        </Button>
                        <Button
                            variant="outline-secondary"
                            onClick={() => history(-1)}
                            style={{
                                background: 'white',
                                border: '1px solid #ddd',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '0',
                                fontSize: '14px',
                                color: '#5a6acf',
                                cursor: 'pointer',
                                flexShrink: 0
                            }}
                        >
                            <BackIcon />
                        </Button>
                    </div>
                </div>

                {/* Table Section - Made horizontally scrollable */}
                <div style={{ overflowX: 'auto', width: '100%' }}>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        minWidth: '700px' // Ensure table doesn't get too narrow
                    }}>
                        <thead>
                            <tr style={{ textAlign: 'left', fontWeight: 600, fontSize: '14px', color: '#555' }}>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '20%' }}>Category Name</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '30%' }}>Description</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '10%', textAlign: 'center' }}>Document Count</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '15%', textAlign: 'center' }}>Actions</th>
                                <th style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', width: '15%', textAlign: 'center' }}>Created Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'center', padding: '14px 10px' }}>
                                        <SectionLoader label="Loading categories..." className="revize-section-loader--table" />
                                    </td>
                                </tr>
                            ) : filteredCategories.length === 0 ? (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'center', padding: '14px 10px', color: '#888' }}>
                                        No categories found.
                                    </td>
                                </tr>
                            ) : (
                            filteredCategories.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                        {item.name}
                                    </td>
                                    <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0' }}>
                                        {item.description}
                                    </td>
                                    <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                        {item.category_document_count}
                                    </td>
                                    <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', alignItems: 'center', color: '#555' }}>
                                            <OverlayTrigger placement="top" overlay={<Tooltip>Update Category</Tooltip>}>
                                                <span
                                                    onClick={() => { handleShowUpdateCategory(item.id, item.name, item.description, item.show_in_bot) }}
                                                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                                                >
                                                    <EditIcon />
                                                </span>
                                            </OverlayTrigger>

                                            <OverlayTrigger placement="top" overlay={<Tooltip>Delete Category</Tooltip>}>
                                                <span
                                                    onClick={() => { showDeleteModal(item.uuid, item.name, item.category_document_count); }}
                                                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                                                >
                                                    <DeleteIcon />
                                                </span>
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td style={{ padding: '14px 10px', borderBottom: '1px solid #f0f0f0', textAlign: 'center' }}>
                                        {moment(item.created_time).format("MM/DD/YY, HH:mm")}
                                    </td>
                                </tr>
                            ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Add Category Modal */}
            <Modal show={showAddCategory} onHide={handleCloseAddCategory}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Category Name</Form.Label>
                        <Form.Control
                            style={{ borderColor: categoryNameError.length > 0 ? "red" : null }}
                            type="text"
                            placeholder="Category Name"
                            onChange={e => handleCategoryName(e.target.value)}
                            onBlur={validateCategoryName}
                            maxLength={30}
                        />
                        <span style={{ color: "red" }}>
                            {categoryNameError}
                        </span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            style={{ borderColor: descriptionError.length > 0 ? "red" : null }}
                            type="textarea"
                            placeholder="Description"
                            onChange={e => handleDescription(e.target.value)}
                            onBlur={validateDescription}
                            maxLength={100}
                        />
                        <span style={{ color: "red" }}>
                            {descriptionError}
                        </span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Check
                            type="checkbox"
                            label="Show in Chat-Bot"
                            checked={showInBot}
                            onChange={e => handleShowInBot(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleCloseAddCategory}
                        style={{ border: '1px solid #ddd', minWidth: '100px' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={!areAllCategoryFieldsFilled}
                        variant="primary"
                        onClick={() => {
                            addCategory()
                            handleCloseAddCategory()
                        }}
                        style={{
                            backgroundColor: '#5a6acf',
                            borderColor: '#5a6acf',
                            minWidth: '100px'
                        }}
                    >
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Update Category Modal */}
            <Modal show={showUpdateCategory} onHide={handleCloseUpdateCategory} onShow={handleModalShow}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Category Name</Form.Label>
                        <Form.Control
                            style={{ borderColor: categoryNameError.length > 0 ? "red" : null }}
                            type="text"
                            placeholder="Category Name"
                            defaultValue={categoryName}
                            onChange={e => handleCategoryName(e.target.value)}
                            onBlur={validateCategoryName}
                            maxLength={100}
                        />
                        <span style={{ color: "red" }}>
                            {categoryNameError}
                        </span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            style={{ borderColor: descriptionError.length > 0 ? "red" : null }}
                            type="textarea"
                            placeholder="Description"
                            defaultValue={description}
                            onChange={e => handleDescription(e.target.value)}
                            onBlur={validateDescription}
                            maxLength={100}
                        />
                        <span style={{ color: "red" }}>
                            {descriptionError}
                        </span>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Check
                            type="checkbox"
                            label="Show in Chat-Bot"
                            checked={showInBot}
                            onChange={e => handleShowInBot()}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={handleCloseUpdateCategory}
                        style={{ border: '1px solid #ddd', minWidth: '100px' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={!areAllCategoryFieldsFilled}
                        variant="primary"
                        onClick={() => {
                            updateCategory()
                            handleCloseUpdateCategory()
                        }}
                        style={{
                            backgroundColor: '#5a6acf',
                            borderColor: '#5a6acf',
                            minWidth: '100px'
                        }}
                    >
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

            <DeleteConfirmation
                showModal={deleteConfirmationModal}
                proceedDelete={proceedDelete}
                confirmModal={deleteCategory}
                hideModal={hideDeleteConfirmationModal}
                uuid={uuid}
                categoryName={categoryName}
                message={confirmMessage} />
        </div>
    )
}

export default SiteCategories